/**
 * If the value is a number and not NaN, return true, otherwise return false.
 * @param {unknown} value - unknown
 * @returns true
 */

export function isNumber(value: unknown): boolean {
  return typeof value === 'number' && !isNaN(value)
}
